<script setup>
import SlideOver from '@/components/SlideOver.vue';
import { useModal } from '@/composables/useModal.js';
import AppButton from '@/components/AppButton.vue';
import { useForm } from '@inertiajs/vue3';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';
import BadgePill from '@/components/BadgePill.vue';
import { computed } from 'vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

const props = defineProps({
    subject: {
        type: Object,
        required: true,
    },
});

const form = useForm({
    expected_levels: props.subject.expectedLevels,
});

const submit = () => {
    form.transform(function (data) {
        data.expected_levels = data.expected_levels.map((gradeLevel) => {
            return {
                grade_level_id: gradeLevel.grade_level_id,
                level: gradeLevel.level,
            };
        });
        return data;
    }).patch(props.subject.links.update_expected_levels, {
        preserveScroll: true,
        onSuccess: function onSuccess() {
            form.expected_levels = props.subject.expectedLevels;
            dismiss();
        },
    });
};

const filteredExpectedLevels = computed(() => {
    return props.subject.expectedLevels.filter((gradeLevel) => {
        return gradeLevel.level !== null;
    });
});

const { isOpen, dismiss } = useModal(false);
</script>

<template>
    <div>
        <div>
            {{ $tc('messages.expected_levels', 2) }}
        </div>
        <div class="flex flex-wrap gap-2 items-center">
            <BadgePill v-for="gradeLevel in filteredExpectedLevels" :key="gradeLevel.grade_level_id" color="gray">
                {{ gradeLevel.name }}: {{ gradeLevel.level || 'N/A' }}
            </BadgePill>
            <AppButton element="button" type="button" @click="isOpen = !isOpen">
                {{ $t('messages.edit') }}
            </AppButton>
        </div>
        <SlideOver :show="isOpen" @close="dismiss" :title="$tc('messages.expected_levels', 2)">
            <div>
                {{ $tc('messages.grade_levels', 2) }}
            </div>
            <form @submit.prevent="submit" id="expected_levels">
                <div v-for="(gradeLevel, index) in form.expected_levels" :key="gradeLevel.grade_level_id" class="mt-3">
                    <FormLabel :value="gradeLevel.name" />
                    <FormInput
                        v-model="gradeLevel.level"
                        type="number"
                        step="1"
                        min="1"
                        max="5"
                        :placeholder="`1-5 ${$t('messages.(optional)')}`"
                        class="w-full"
                    />
                    <FormError :value="form.errors[`expected_levels.${index}.level`]" />
                </div>
            </form>
            <template v-slot:bottom>
                <div class="flex justify-end">
                    <SubmitFormButton
                        :button-text="$t('messages.save')"
                        :processing="form.processing"
                        form="expected_levels"
                    />
                </div>
            </template>
        </SlideOver>
    </div>
</template>
